// @ts-nocheck

import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
const USER_APP_TERMS_ENDPOINT = '/v1/user-app-terms';
const GetUserAppTerms = new ReduxAsyncAction('GET_USER_APP_TERMS');
GetUserAppTerms.registerRequest(function () {
  return dash_api.get(USER_APP_TERMS_ENDPOINT).then(({ data }) => {
    return data;
  });
});
export const GET_USER_APP_TERMS = GetUserAppTerms.constants;
export const getUserAppTerms = GetUserAppTerms.request;
const UpdateUserAppTerm = new ReduxAsyncAction('UPDATE_USER_APP_TERM');
UpdateUserAppTerm.registerRequest(function (resource: string, hasAgreed: boolean) {
  return dash_api
    .put(USER_APP_TERMS_ENDPOINT, {
      resource,
      hasAgreed,
    })
    .then(({ data }) => data);
});
export const UPDATE_USER_APP_TERM = UpdateUserAppTerm.constants;
export const updateUserAppTerm = UpdateUserAppTerm.request;
